import { Space } from 'antd'
import MoveJob from "./MoveJob"
import CopyJob from "./CopyJob"
import DeleteJob from "./DeleteJob"
import ArchiveJob from "./ArchiveJob"

type Props = {
  jobId: number
  jobName?: string
  jobType?: number
  sold?: boolean
}

const JobOperations = ({ jobId, jobName, jobType, sold }: Props) => {
  return <Space>
    <ArchiveJob jobId={jobId} jobName={jobName} jobType={jobType} sold={sold} />
    <DeleteJob jobId={jobId} />
    <CopyJob jobId={jobId} />
    <MoveJob jobId={jobId} />
  </Space>
}
export default JobOperations
